import { ApplicationTypes } from 'metalworks-domain'
import { useCallback, useEffect, useState } from 'react'

import { Dialog } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../../systems/configurator-interface'
import { FinalizeSuccessDialogContent } from './SuccessDialog'
import { BulkFinalizationWizard } from './bulk-kick-plate/BulkFinalizationWizard'
import { SinglePlateJobDetailsDialog } from './single-plate/SinglePlateJobDetailsDialog'

export const FinalizationPage = () => {
  const navigationStateTag = configuratorInterface.useActiveNavigationState()
  const [filteredNavigationState, setFilteredNavigationState] = useState<ApplicationTypes.NavigationState | null>(
    navigationStateTag
  )

  const [success, setSuccess] = useState(false)
  const [returnUrl, setReturnUrl] = useState<string | null>(null)

  const handleSuccess = useCallback((returnUrl: string | null) => {
    setSuccess(true)
    setReturnUrl(returnUrl)
  }, [])

  // Ignore FinalizationThumbnail state - this changes during finalization
  // and it would re-render finalization wizard and start from scratch.
  useEffect(() => {
    if (navigationStateTag !== ApplicationTypes.NavigationState.FinalizationThumbnail) {
      setFilteredNavigationState(navigationStateTag)
    }
  }, [navigationStateTag])

  if (
    filteredNavigationState !== ApplicationTypes.NavigationState.Finalization &&
    filteredNavigationState !== ApplicationTypes.NavigationState.BulkFinalization
  ) {
    return null
  }

  // Success dialog for all finalization types
  if (success) {
    return (
      <Dialog.Root variant="static" sx={{ width: '90%', maxWidth: '970px' }}>
        <FinalizeSuccessDialogContent returnUrl={returnUrl} />
      </Dialog.Root>
    )
  }

  // Bulk finalization dialog
  if (filteredNavigationState === ApplicationTypes.NavigationState.BulkFinalization) {
    return <BulkFinalizationWizard onSuccess={handleSuccess} />
  }

  // Standard finalization dialog
  return <SinglePlateJobDetailsDialog onSuccess={handleSuccess} />
}
